import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import { FileIcon } from "@shopify/polaris-icons";
import { EDITOR_CONFIG } from "../../constants";
import JoditEditor from "jodit-react";

const AddEditItem = (props) => {
  const navigate = useNavigate();
  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/[\s_-]+/g, "-")
      .replace(/^-+|-+$/g, "");
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const imageKey = useRef("");
  const logoKey = useRef("");
  const videoKey = useRef("");
  const editor = useRef(null);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [item, setItem] = useState({
    subtitle: "",
    title: "",
    description: "",
    image: "",
    logo: "",
    isActive: true,
    video: "",
  });

  const handleChangeTitle = (newValue) => {
    setItem({ ...item, title: newValue });
    setTitleError("");
  };
  const [titleError, setTitleError] = useState("");
  const handleChangeSubtitle = (newValue) => {
    setItem({ ...item, subtitle: newValue });
  };
  const handleChangeDescription = (newValue) => {
    setItem({ ...item, description: newValue });
  };

  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };

  const [files, setFiles] = useState([]);
  const handleDropZone = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );
  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
  const fileUpload = !files.length && (
    <DropZone.FileUpload
      actionHint={"Accepts jpegs and pngs (Required size: 1080x1920 pixels)"}
    />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const sendImage = (files) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "intro_content");
    form_data.append("image", files[files.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          image:
            validImageTypes.indexOf(files[files.length - 1].type) > 0
              ? window.URL.createObjectURL(files[files.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
        setImageError("");
      })
      .catch(function (error) {});
  };

  const [filesVideo, setFilesVideo] = useState([]);
  const handleDropZoneVideo = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesVideo((filesVideo) => [...filesVideo, ...acceptedFiles]),
    []
  );
  const fileUploadVideo = !filesVideo.length && (
    <DropZone.FileUpload actionHint={"Accepts mp4"} />
  );
  const uploadedFilesVideo = filesVideo.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(filesVideo[filesVideo.length - 1].type)
              ? window.URL.createObjectURL(filesVideo[filesVideo.length - 1])
              : NoteIcon
          }
        />
        <div>
          {filesVideo[filesVideo.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {filesVideo[filesVideo.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const sendVideo = (filesVideo) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "intro_content");
    form_data.append("video", filesVideo[filesVideo.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        videoKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          video:
            validImageTypes.indexOf(filesVideo[filesVideo.length - 1].type) > 0
              ? window.URL.createObjectURL(filesVideo[filesVideo.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };

  const [filesLogo, setFilesLogo] = useState([]);
  const handleDropZoneLogo = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesLogo((filesLogo) => [...filesLogo, ...acceptedFiles]),
    []
  );
  const fileUploadLogo = !filesLogo.length && (
    <DropZone.FileUpload
      actionHint={
        "Accepts svgs, jpegs and pngs (Required size: 200x200 pixels)"
      }
    />
  );
  const uploadedFilesLogo = filesLogo.length > 0 && (
    <div style={{ padding: "0" }}>
      {filesLogo.map((file, index) => (
        <div key={index} className="rowDiv">
          <Thumbnail
            size="small"
            alt={file.title}
            source={
              validImageTypes.includes(file.type)
                ? window.URL.createObjectURL(file)
                : NoteIcon
            }
          />
          <div>
            {file.title}{" "}
            <Text variant="bodySm" as="p">
              {file.size} bytes
            </Text>
          </div>
        </div>
      ))}
    </div>
  );
  const sendImageLogo = (filesLogo) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "intro_content");
    form_data.append("image", filesLogo[filesLogo.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        logoKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          logo:
            validImageTypes.indexOf(filesLogo[filesLogo.length - 1].type) > 0
              ? window.URL.createObjectURL(filesLogo[filesLogo.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };
  const [imageError, setImageError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  useEffect(() => {
    props.type === "edit" &&
      axios
        .get(`/intro-content/${id}`)
        .then((result) => {
          console.log(result.data.data);
          setItem({
            title: result?.data?.data?.title ? result.data.data.title : "",
            subtitle: result?.data?.data?.subtitle
              ? result.data.data.subtitle
              : "",
            description: result?.data?.data?.description
              ? result.data.data.description
              : "",
            image: result?.data?.data?.background_image
              ? result?.data?.data?.background_image
              : "",
            video: result?.data?.data?.video
              ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
              : "",
            logo: result?.data?.data?.image ? result?.data?.data?.image : "",
            isActive: result?.data?.data?.is_active ? true : false,
          });
          setIsSaving(false);
        })

        .catch((err) => console.log(err));
  }, []);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/intro-content/${id}`)
      .then((result) => {
        navigate("/admin/intro-screens");
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Page`}
      backAction={{ onAction: () => navigate("/admin/intro-screens") }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              value={item.title}
              onChange={handleChangeTitle}
              label="Title"
              error={titleError}
            />
            <TextField
              value={item.subtitle}
              onChange={handleChangeSubtitle}
              label="Subtitle"
            />
          </FormLayout.Group>

          {/* <Text>Description </Text> */}
          <TextField
            value={item.description}
            onChange={handleChangeDescription}
            label="Description"
            multiline={5}
          />
          {/* <JoditEditor
            ref={editor}
            value={item.description}
            config={EDITOR_CONFIG}
            onBlur={handleChangeDescription}
          /> */}

          <Text>Logo</Text>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.logo ? item.logo : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".svg,.jpeg,.jpg,.png"
                onDrop={handleDropZoneLogo}
                allowMultiple={false}
                onDropAccepted={sendImageLogo}
              >
                {uploadedFilesLogo}
                {fileUploadLogo}
              </DropZone>
            </div>
          </div>

          <Text>Background Image</Text>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.image ? item.image : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".svg,.jpeg,.jpg,.png"
                onDrop={handleDropZone}
                allowMultiple={false}
                onDropAccepted={sendImage}
              >
                {uploadedFiles}
                {fileUpload}
              </DropZone>
            </div>
          </div>
          <InlineError message={imageError} />

          <Text>Video</Text>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.video ? item.video : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".mp4"
                onDrop={handleDropZoneVideo}
                allowMultiple={false}
                onDropAccepted={sendVideo}
              >
                {uploadedFilesVideo}
                {fileUploadVideo}
              </DropZone>
            </div>
          </div>

          <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeActive}
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => setActiveDelete(true)}
            >
              Delete
            </Button>
          )
        }
      />
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (!item.title || (!imageKey.current && props.type === "add")) {
      !item.title && setTitleError("This field is required");
      !imageKey.current &&
        props.type === "add" &&
        setImageError("Please upload an image");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      item.title && form_data.append("title", item.title);
      // item.title && form_data.append("alias", slugify(item.title));
      item.subtitle && form_data.append("subtitle", item.subtitle);
      item.description && form_data.append("description", item.description);
      imageKey.current &&
        form_data.append("background_image", imageKey.current);
      logoKey.current && form_data.append("image", logoKey.current);
      videoKey.current && form_data.append("video", videoKey.current);
      form_data.append("is_active", item.isActive ? 1 : 0);
      props.type === "edit" && form_data.append("_method", "PATCH");

      props.type === "add"
        ? axios
            .post(`/intro-content`, form_data)
            .then((result) => {
              navigate("/admin/intro-screens");
            })
            .catch((err) => console.log(err))
        : axios
            .post(`/intro-content/${id}`, form_data)
            .then((result) => {
              toggleActive();
              setIsSaving(false);
            })
            .catch((err) => console.log(err));
    }
  }
};

export default AddEditItem;
